import fetcher from 'api/fetcher';
import { AdminInvoiceCreateError } from 'utils/constants/admin';

import { setInvoiceInfo } from 'store/models/payers';

const makeInvoice = (setLoad, setCreatedInvoice, setErrors) => {
    return (dispatch, getState) => {
        setLoad(true);
        const { invoicePayer, invoiceAmount, invoiceAccountId } = getState().payers;
        const body = {
            payerId: invoicePayer?.payerId,
            amount: invoiceAmount,
            accountId: invoiceAccountId,
        };
        fetcher
            .post('/api/v1/backoffice/payers/create_invoice/', body)
            .then(({ id, number, createdAt }) => {
                dispatch(setInvoiceInfo({ id, number, createdAt }));
                setCreatedInvoice(true);
            })
            .catch((err) => {
                if (err?.response?.status === 400) {
                    const errors = {};
                    err.response.data.errors.forEach(({ key }) => {
                        switch (key) {
                            case AdminInvoiceCreateError.EmptyAmount:
                                errors.amount = key;
                                break;
                            case AdminInvoiceCreateError.EmptyAccountId:
                                errors.accountId = key;
                                break;
                            case AdminInvoiceCreateError.UnnecessaryAccountId:
                                errors.accountId = key;
                                break;
                        }
                    });
                    setErrors(errors);
                }
            })
            .finally(() => setLoad(false));
    };
};

export default makeInvoice;
